<template>
  <main class="bg-[#eef1f3]">
    <section class="py-16 tablet:pt-24">
      <div class="grid-container">
        <div class="col-span-12">
          <JobWizardStepFeaturesOfferTypes
            class="mb-8"
            :model-value="offerType"
            :features-lookup="featuresLookup"
            @update:model-value="offerType = $event"
          />

          <h3 class="mb-5 text-headline-m">
            {{ $t('create.optional_features') }}
          </h3>

          <JobWizardStepFeaturesTabs :features-lookup="featuresLookup" />
        </div>
      </div>
    </section>

    <JobWizardFooter
      :job-offer-price="jobOfferPrice || undefined"
      :show-price="isNewJob"
      :step-count="stepCount"
      :current-step-count="currentStepCount"
      :validator="$v"
      @next-step="$emit('nextStep')"
      @previous-step="$emit('previousStep')"
    />
  </main>
</template>

<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { computed, onMounted } from 'vue'

import JobWizardFooter from '@/components/CreateJob/JobWizardFooter.vue'
import { useFeatures } from '@/composables/useFeatures'
import { JOB_OFFER_TYPE } from '@/helpers/constants'

import JobWizardStepFeaturesOfferTypes from './JobWizardStepFeaturesOfferTypes.vue'
import JobWizardStepFeaturesTabs from './JobWizardStepFeaturesTabs.vue'

import { useNewJobStore } from '~/store/newJob'

defineOptions({
  inheritAttrs: false,
})

const store = useNewJobStore()

const { featuresLookup, fetchFeatures } = useFeatures()

defineProps<{
  isNewJob?: boolean
  stepCount: number
  currentStepCount: number
}>()

defineEmits(['nextStep', 'previousStep'])

onMounted(() => {
  if (!offerType.value) {
    offerType.value = JOB_OFFER_TYPE.STANDARD
  }
})

fetchFeatures()

const offerType = computed({
  get() {
    return store.jobOffer.offerType
  },
  set(value) {
    store.updateJobOffer({ offerType: value })
  },
})

const jobOfferPrice = computed(() => {
  return store.jobOfferPrice
})

const rules = {
  jobOfferPrice: { required },
}

const $v = useVuelidate(rules, {
  jobOfferPrice,
})
</script>
